module.exports = __webpack_public_path__ + "images/category_lp/hobby/assessment_achievements/5@2x_458201894d1f4c0ac49dc2f05e2dbcf4.png";